import React, { useCallback } from 'react';
import { Auth0Provider, AppState } from "@auth0/auth0-react";
import { useNavigate } from 'react-router-dom';
import { ConvexProviderWithAuth0 } from "convex/react-auth0";
import { AuthProvider } from '../contexts/AuthContext';
import { convex } from './convexClient';

interface CoreProvidersProps {
  children: React.ReactNode;
}

export const CoreProviders: React.FC<CoreProvidersProps> = ({ children }) => {
  const navigate = useNavigate();

  // Auth0's default callback only calls history.replaceState, which React Router
  // never sees, so `returnTo` (e.g. resuming checkout on /pricing) was ignored.
  const onRedirectCallback = useCallback((appState?: AppState) => {
    let target = appState?.returnTo || '/';
    try {
      const url = new URL(target, window.location.origin);
      target = url.origin === window.location.origin ? url.pathname + url.search + url.hash : '/';
    } catch {
      target = '/';
    }
    navigate(target, { replace: true });
  }, [navigate]);

  return (
    <Auth0Provider
      domain="auth.cognora.ca"
      clientId="gawLQLofX6FcUA9LtgMDJv16CxSn93hG"
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      onRedirectCallback={onRedirectCallback}
    >
      {/* Convex verifies the Auth0 ID token, so it sits inside Auth0Provider. */}
      <ConvexProviderWithAuth0 client={convex}>
        <AuthProvider>
          {children}
        </AuthProvider>
      </ConvexProviderWithAuth0>
    </Auth0Provider>
  );
};
